export default "__VITE_ASSET__67bc00db__"